export default {
  dashboard: {
    sys: "YSystem 酒店端",
    title: "看板",
    dim_selection: {
      today: "今天",
      yesterday: "昨天",
      recentWeek: "近7天",
      recentMonth: "近30天",
      halfYear: "近半年",
      recentYear: "近一年",
      currentMonth: "本月",
      currentYear: "当年"
    },
    roomNights: "房间夜晚",
    yesterday: "昨天",
    lastYearSamePange: "同比数据",
    totalAmount: "总金额",
    compareHotels: "比较酒店",
    collect: "收起",
    showAll: "展示全部",
    turnoverByAgency: "渠道营业额",
    totalBookingAmount: "总预订金额",
    agency: "渠道",
    bookingAmount: "预订金额",
    totalRoomNights: "总间夜数"
  }
};
